export default "__VITE_ASSET__Cvz2zleI__"